import { z } from 'zod';

const envSchema = z.object({
  VITE_AUTH0_DOMAIN: z.string(),
  VITE_AUTH0_CLIENT_ID: z.string(),
  VITE_AUTH0_AUDIENCE: z.string(),
  VITE_ENVIRONMENT_NAME: z.string(),
  VITE_GRAPHQL_URL: z.string(),
  VITE_SENTRY_DSN: z.string(),
  VITE_RAILS_APP_BASE_URL: z.string().url(),
});

const env = envSchema.parse(import.meta.env);

export const AUTH0_DOMAIN = env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = env.VITE_AUTH0_AUDIENCE;
export const ENVIRONMENT_NAME = env.VITE_ENVIRONMENT_NAME;
export const GRAPHQL_URL = env.VITE_GRAPHQL_URL;
export const WS_URL = GRAPHQL_URL.replace(/^http/, 'ws');
export const SENTRY_DSN = env.VITE_SENTRY_DSN;

/** Base URL of the legacy Rails app (dev / staging / prod). Trailing slashes stripped. */
export const RAILS_APP_BASE_URL = env.VITE_RAILS_APP_BASE_URL;

export const FOOTER_SUPPORT_URL = `${RAILS_APP_BASE_URL}/pages/support`;

export const RAILS_EXPERTS_URL = `${RAILS_APP_BASE_URL}/experts`;

export const RAILS_EDIT_EXPERT_PROFILE_URL = `${RAILS_APP_BASE_URL}/experts/profile/edit`;

export const IS_DEV = import.meta.env.DEV;
